import { Shield, Award, Calendar, Building, IndianRupee, Ruler } from 'lucide-react';
import { projectData } from '@/data/project';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

const TrustStrip = () => {
  return (
    <section className="bg-primary py-4 border-b border-white/10 relative z-30">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 lg:gap-8">
          {/* RERA Registered */}
          <div className="flex items-center gap-2 text-primary-foreground">
            <Shield className="w-4 h-4 text-accent flex-shrink-0" aria-hidden="true" />
            <span className="text-xs md:text-sm font-medium">
              <span className="hidden sm:inline">MahaRERA: </span>
              {projectData.rera.number}
            </span>
          </div>

          <div className="hidden sm:block w-px h-4 bg-white/20" aria-hidden="true" />

          {/* Developer */}
          <div className="flex items-center gap-2 text-primary-foreground">
            <Award className="w-4 h-4 text-accent flex-shrink-0" aria-hidden="true" />
            <span className="text-xs md:text-sm font-medium">
              {projectData.developer.name}
            </span>
          </div>

          <div className="hidden sm:block w-px h-4 bg-white/20" aria-hidden="true" />

          {/* Possession */}
          <div className="flex items-center gap-2 text-primary-foreground">
            <Calendar className="w-4 h-4 text-accent flex-shrink-0" aria-hidden="true" />
            <span className="text-xs md:text-sm font-medium">
              Possession: Dec 2030
            </span>
          </div>

          <div className="hidden md:block w-px h-4 bg-white/20" aria-hidden="true" />

          {/* Config Summary */}
          <div className="flex items-center gap-2 text-primary-foreground">
            <Building className="w-4 h-4 text-accent flex-shrink-0" aria-hidden="true" />
            <span className="text-xs md:text-sm font-medium">
              <span className="hidden lg:inline">Primarily </span>3 & 4 BHK
            </span>
          </div>

          <div className="hidden lg:block w-px h-4 bg-white/20" aria-hidden="true" />

          {/* Starting Price - NEW */}
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <div className="hidden lg:flex items-center gap-2 text-primary-foreground cursor-help">
                  <IndianRupee className="w-4 h-4 text-accent flex-shrink-0" aria-hidden="true" />
                  <span className="text-xs md:text-sm font-medium">
                    From ₹2.90 Cr+*
                  </span>
                </div>
              </TooltipTrigger>
              <TooltipContent side="bottom" className="max-w-xs text-center">
                <p className="text-xs">Indicative pricing; subject to availability and change. Excludes stamp duty, GST & registration.</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>

          <div className="hidden xl:block w-px h-4 bg-white/20" aria-hidden="true" />

          {/* Sizes - NEW */}
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <div className="hidden xl:flex items-center gap-2 text-primary-foreground cursor-help">
                  <Ruler className="w-4 h-4 text-accent flex-shrink-0" aria-hidden="true" />
                  <span className="text-xs md:text-sm font-medium">
                    886–2,487 sq.ft.*
                  </span>
                </div>
              </TooltipTrigger>
              <TooltipContent side="bottom" className="max-w-xs text-center">
                <p className="text-xs">Total area includes RERA carpet + deck + utility where applicable.</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>

        {/* Mobile-only pricing anchor */}
        <div className="flex lg:hidden justify-center mt-3 pt-3 border-t border-white/10">
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <div className="flex items-center gap-4 text-primary-foreground cursor-help">
                  <span className="text-xs font-medium flex items-center gap-1.5">
                    <IndianRupee className="w-3.5 h-3.5 text-accent" aria-hidden="true" />
                    From ₹2.90 Cr+*
                  </span>
                  <span className="w-px h-3 bg-white/20" aria-hidden="true" />
                  <span className="text-xs font-medium flex items-center gap-1.5">
                    <Ruler className="w-3.5 h-3.5 text-accent" aria-hidden="true" />
                    886–2,487 sq.ft.*
                  </span>
                </div>
              </TooltipTrigger>
              <TooltipContent side="bottom" className="max-w-xs text-center">
                <p className="text-xs">Indicative; subject to availability and change.</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;